import { FC } from 'react'
import './Supplier.css'

import { ExpenseSelect } from '../../../components/parts'
interface DropDownCommandCellProps {
  dropDownVal: string
  handleOnChange: (value: string) => void
  disabled?: boolean
}

export const DropDownCommandCell: FC<DropDownCommandCellProps> = (props) => {
  return (
    <td className="k-command-cell">
      <ExpenseSelect
        value={[props.dropDownVal]}
        defaultValue={[props.dropDownVal]}
        onChange={(value) => {
          props.handleOnChange(value[0])
        }}
        popupSettings={{ className: 'pcy-dropdownlist' }}
        disabled={props.disabled}
      />
    </td>
  )
}
